import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import {
  CreateEphemeralKeyPayload,
  CreateEphemeralKeyRequestBody,
  CreateEphemeralKeyResponse,
  GetCardByIdPayload,
  GetCardByIdResponse
} from './treasury.model';

const TreasuryBaseAPI = baseApi.injectEndpoints({
  endpoints: builder => ({
    createEphemeralKey: builder.mutation<CreateEphemeralKeyResponse, CreateEphemeralKeyPayload>({
      query: ({ spendAccountId, spendAccountCardId, nonce, teamId, cardId }) => ({
        // eslint-disable-next-line max-len
        url: `${API_VERSION.V1}/banking/teams/${teamId}/spend-accounts/${spendAccountId}/cards/${spendAccountCardId}/ephemeral-key`,
        method: 'POST',
        body: {
          cardId,
          nonce
        } as CreateEphemeralKeyRequestBody
      }),
      extraOptions: {
        failure: 'Failed to create ephemeral key',
        showToast: true
      }
    }),
    getCardById: builder.query<GetCardByIdResponse, GetCardByIdPayload>({
      query: ({ teamId, spendAccountId, cardId }) => ({
        url: `${API_VERSION.V1}/banking/teams/${teamId}/spend-accounts/${spendAccountId}/cards/${cardId}`,
        method: 'GET'
      }),
      extraOptions: {
        failure: 'Failed to fetch card details',
        showToast: true
      }
    })
  })
});

export const { useCreateEphemeralKeyMutation, useLazyGetCardByIdQuery } = TreasuryBaseAPI;
